import {call, put, takeLatest, delay} from 'redux-saga/effects'
import {actions} from './action'
import {actionTypes} from './constants'
import {ResponseModel} from 'src/cms/helpers/Models/ResponseModel'
import {service} from './service'
import {ActionModel} from 'src/cms/helpers/Models/ActionModel'
import {globalActionTypes} from 'src/app/modules/errors/redux/constants'
import {ParamsModel} from 'src/app/modules/common/Model'

function* getApplicationsSaga(action: ActionModel) {
  try {
    const params: ParamsModel = action.payload
    yield delay(500)
    const response: ResponseModel = yield call(service.getApplications, params)
    yield put(actions.getApplicationsSuccess(response?.data?.data))
    yield put(actions.getApplicationsFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.getApplicationsFinish())
  }
}

function* deleteApplicationsSaga(action: ActionModel) {
  try {
    const body: any = action.payload
    const response: ResponseModel = yield call(service.deleteApplications, body)
    yield put(actions.deleteApplicationsSuccess(response.data?.data))
    yield delay(0.1)
    yield put(actions.deleteApplicationsFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.deleteApplicationsFinish())
  }
}

export function* saga() {
  yield takeLatest(actionTypes.GET_APPLICATION_START, getApplicationsSaga)
  yield takeLatest(actionTypes.DELETE_APPLICATION_START, deleteApplicationsSaga)
}
